module.exports = __webpack_public_path__ + "img/6mm3mm.a513ccd7.jpeg";